import classNames from "classnames";
import { CloseButton, Collapse, Expand, ExportIcon, ResetIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import { ReactNode } from "react";
import "./index.css";

interface SidebarProps {
    onCancel: () => void;
    sidebarOpen: boolean;
    title: ReactNode;
    children: ReactNode;
    headerContent?: ReactNode;
    onReset?: () => void;
    onDownload?: () => void;
    isDownloading?: boolean;
    noBodyPadding?: boolean;
    isExpanded?: boolean;
    canBeExpanded?: boolean;
    setIsExpanded?: (isExpanded: boolean) => void;
    positionBelowHeader?: boolean;
}

function Sidebar({
    onCancel,
    sidebarOpen,
    title,
    children,
    headerContent,
    onReset,
    onDownload,
    isDownloading,
    noBodyPadding,
    isExpanded,
    canBeExpanded,
    setIsExpanded,
    positionBelowHeader,
}: SidebarProps) {
    return (
        <div
            className={classNames(
                "sidebar",
                sidebarOpen ? "show" : "hidden",
                isExpanded && "is-expanded",
                positionBelowHeader && "sidebarBelowHeader"
            )}
        >
            <div className="sidebar--header">
                {headerContent || (
                    <>
                        <Header size="small" weight="bold">
                            {title}
                        </Header>
                        <div className="sidebar--header-actions">
                            {onDownload && (
                                <button
                                    onClick={onDownload}
                                    type="button"
                                    className="sidebar-download"
                                    title={isDownloading ? "Generating HTML..." : "Download conversation"}
                                    disabled={isDownloading}
                                >
                                    {isDownloading ? <div className="loading-spinner" /> : <ExportIcon />}
                                </button>
                            )}
                            {onReset && (
                                <button onClick={onReset} type="button" className="sidebar-reset">
                                    <ResetIcon />
                                </button>
                            )}
                            {canBeExpanded && (
                                <button
                                    onClick={() => setIsExpanded && setIsExpanded(!isExpanded)}
                                    type="button"
                                    className="sidebar-expand"
                                >
                                    {!isExpanded ? <Expand /> : <Collapse />}
                                </button>
                            )}
                            <CloseButton onClick={onCancel} />
                        </div>
                    </>
                )}
            </div>
            <div className={classNames("sidebar--body", noBodyPadding && "no-padding")}>{children}</div>
        </div>
    );
}

export default Sidebar;
